import { IdentityType } from '~/redux-modules/identity/type'

export function getHotjarIdentityObj(identity: IdentityType) {
    const { createdAt, email } = identity

    return {
        account_created_at: createdAt,
        email,
    }
}
